import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { pricingActions, pricingSelectors } from '../../../store/modules/pricing';

const usePricingSale = () => {
  const dispatch = useDispatch();
  const sale = useSelector(pricingSelectors.selectSale, shallowEqual);

  const coupon = useSelector(pricingSelectors.selectCurrentSaleCoupon);
  const discount = useSelector(pricingSelectors.selectCurrentSaleDiscount);

  useEffect(() => {
    if (!!sale) return;

    dispatch(pricingActions.fetchSale());
  }, [!!sale]);

  return coupon && discount && { coupon, discount };
};

export default usePricingSale;
